import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Note } from 'app/modules/admin/apps/file-manager/notes/notes.types';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({providedIn: 'root'})
export class NotesService
{
    // Private
    private _notes: BehaviorSubject<any> = new BehaviorSubject(null);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient)
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for notes
     */
    get notes(): Observable<any>
    {
        return this._notes.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get notes
     * TODO - get by item id
     */
    getNotes(): Observable<any>
    {
        return this._httpClient.get<Note[]>('api/apps/file-manager/notes').pipe(
            tap((response: Note[]) =>
            {
                this._notes.next(response);
            }),
        );
    }
}
